/**
 * Created by staffanrantzow on 16/11/16.
 */

import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import { Spinner } from 'components';
import { UserService, TaxkeyService } from 'frilans-finans';
import { authenticationService } from 'interactive-solutions/authentication';

class TokenLogin extends React.Component {

  static propTypes = {
    location: PropTypes.object.isRequired
  };

  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      loggingIn: true,
      loginFailed: false
    };

    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  componentDidMount () {
    let accessToken = this.props.location.query.access_token;
    let expiresIn = this.props.location.query.expires_in;

    if (accessToken && expiresIn) {
      authenticationService.logout();
      this.login(accessToken, expiresIn);
    } else {
      this.context.router.push('login');
    }
  }

  login (accessToken, expiresIn) {
    authenticationService.tokenLogin(accessToken, expiresIn);
    let handleSuccess = this.handleSuccess;
    let handleError = this.handleError;

    UserService.get().promise
      .then(function (user) {
        TaxkeyService.get(user.id)
          .then(handleSuccess)
          .catch(handleError);
      })
      .catch(handleError);
  }

  handleSuccess () {
    let redirectUrl = this.props.location.query.redirect;

    if (!redirectUrl) {
      redirectUrl = 'activities';
    }

    this.context.router.push(redirectUrl);
  }

  handleError () {
    authenticationService.logout();

    this.setState({
      loggingIn: false,
      loginFailed: true
    });
  }

  renderContent () {
    if (this.state.loginFailed) {
      return (
        <div className="col-sm-8">
          <p className="error"><Translate content='LOGIN_FAILED'/></p>
        </div>
      );
    }
    if (this.state.loggingIn) {
      return (
        <div className="col-sm-12">
          <Spinner/>
        </div>
      );
    }

    return false;
  }

  render () {
    return (
      <div className="page-wrapper token-login mb35">
        <div className="container">
          <div className="row">
              {this.renderContent()}
          </div>
        </div>
      </div>
    );
  }

}

export default TokenLogin;



/** WEBPACK FOOTER **
 ** ./src/views/token-login/token-login.js
 **/